{
  "comment": "M3 travel tuning (plan R6, §2.2; D-TBD 2, 15, 17, 19). Validated by src/travel/config.ts. Starting values, tuned in playtest. transit.maxSpeed (D-TBD relay speed, user 2026-09-28) is above every hull's absMaxSpeed (480) so any normal-flight approach, boost included, is accepted, and far below cruise.vMin so a cruising ship is still refused. Station ranges count from the hull (scale build, plan §3.3): massLock.stationM and cruise.stationDropFromHullM are measured off a station's bounding sphere R (src/reach/session/siteRadius.ts).",
  "cruise": {
    "comment": "dropDistanceM is the auto-drop distance to relays, POIs, lane rings and hulks (from the centre) and to bodies and fields (from the shell or sphere). stationDropFromHullM (scale build SC-5c): a cruise to a station drops this far off its hull, R + 4,000 m from its centre, inside the docking request range (R + 5,000 m), so home legs don't make the player fly the last 10 km; without the key a station drops dropDistanceM from its centre. The strategic sim's travel.json dropM is separate. While cruising, every other station's hull counts as a shell: the law slows near it and the ship emergency-drops at it.",
    "chargeS": 1.25,
    "k": 0.2,
    "vMin": 1000,
    "vMax": 2e10,
    "lagS": 1.5,
    "surfaceFactor": 10,
    "freeDistanceM": 1e9,
    "rateScale": 0.4,
    "dropDistanceM": 10000,
    "stationDropFromHullM": 4000,
    "dropSpeed": 150,
    "manualCooldownS": 5,
    "emergencyCooldownS": 5,
    "throttleRate": 0.5,
    "minThrottle": 0.05,
    "alignAssistDeg": 3,
    "streamResumeSpeed": 20000
  },
  "massLock": {
    "comment": "stationM is measured from the hull (scale build SC-5a2a, plan §3.3): the drive is locked within R + stationM of a station's centre, R its gameplay radius (the bounding sphere round the model origin, src/reach/session/siteRadius.ts), so the lock starts outside the hull at any station size. relayM and shipM stay from the relay's or ship's centre.",
    "stationM": 600,
    "relayM": 2000,
    "shipM": 3000,
    "weaponLock": true,
    "starShellFactor": 1.05,
    "starShellExtraM": 20000
  },
  "interdiction": {
    "comment": "stationExclusionM stays from the station centre (scale build SC-5a2a): 20 km still clears a 2 km station's hull by about 18 km and covers the whole home cluster, so a moored L at its ring (moor.json, max(ringRadiusM, R + ringClearM) from the centre) is never interdicted: moored = docked. bandRateMult and bandTierStep (M10 P4b6b, P4b-15; validated by src/travel/runtime/interdiction.ts): the flown hull's band multiplies the bridge's interdiction rate (an L in cruise draws 1.5× the M rate) and moves its interdictor group that many cargo tiers up (an L draws the next tier's wave, clamped to the last tier). A band left out is neutral (×1, no step). Every value is [P].",
    "bandRateMult": { "S": 1, "M": 1, "L": 1.5 },
    "bandTierStep": { "S": 0, "M": 0, "L": 1 },
    "ratePerMin": { "gate": 0.05, "mid": 0.2, "deep": 0.35, "rim": 0.5 },
    "rollEveryS": 10,
    "graceAfterArrivalS": 45,
    "cooldownS": 90,
    "stationExclusionM": 20000,
    "escapeS": 5,
    "maxS": 14,
    "coneDeg": 12,
    "escapeDecay": 0.5,
    "offVectorPullMult": 1.8,
    "startOffsetDeg": [25, 60],
    "driftDegPerS": { "rookie": 6, "veteran": 14, "ace": 22 },
    "driftTurnS": [1.5, 3],
    "speedFloor": 0.3,
    "dropSpeed": 100,
    "failCooldownS": 10,
    "spawnRadiusM": [1500, 2500],
    "groups": {
      "gate": [{ "def": "interceptor", "profile": "rookie", "count": 1 }],
      "mid": [{ "def": "interceptor", "profile": "rookie", "count": 2 }],
      "deep": [
        { "def": "interceptor", "profile": "veteran", "count": 2 },
        { "def": "gunship", "profile": "rookie", "count": 1 }
      ],
      "rim": [
        { "def": "interceptor", "profile": "veteran", "count": 2 },
        { "def": "gunship", "profile": "veteran", "count": 1 }
      ]
    }
  },
  "lanes": {
    "kMult": 3,
    "vMaxMult": 3,
    "entryConeDeg": 20,
    "entryMaxSpeed": 400,
    "exitSpeed": 120,
    "exitOffsetM": 200
  },
  "transit": {
    "alignDeg": 20,
    "maxSpeed": 500,
    "enterS": 0.4,
    "tunnelMinS": 3,
    "tunnelMaxS": 8,
    "exitS": 0.6,
    "arrivalOffsetM": 400,
    "arrivalSpeed": 30,
    "hintRangeM": 5000
  }
}
